import httpService from './http.service';


const createRole = (role) => httpService
    .post(`/extrole`, role)
    .then(({data}) => data)
    .catch((err) => {
        throw err;
    });

const updateRole = (role) => httpService
    .put(`/extrole`, role)
    .then(({data}) => data)
    .catch((err) => Promise.reject(err));

const activeRole = (roleId, active) => httpService
    .put(`/extrole/${roleId}/?active=${active}`)
    .then(({data}) => data)
    .catch((err) => Promise.reject(err));

const getAllRoles = () => httpService
    .get('/extrole')
    .then(({data}) => data)
    .catch((err) => Promise.reject(err.response));

const addUserToRole = (userId, roleId) => httpService
    .put(`/extrole/${roleId}/add/${userId}`)
    .then(({data}) => data)
    .catch((err) => Promise.reject(err));

const removeUserToRole = (userId, roleId) => httpService
    .put(`/extrole/${roleId}/remove/${userId}`)
    .then(({data}) => data)
    .catch((err) => Promise.reject(err));


export default {
    getAllRoles, createRole, updateRole, activeRole, addUserToRole, removeUserToRole
};
